import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-manager',
  templateUrl: './manager.component.html',
  styleUrls: ['./manager.component.scss']
})
export class LayoutManagerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
